import React from 'react';

import TableRowActionButton from './table_row_action_button';

const RealizeTableRowActions = window.TableRowActions;

export default class TableRowActions extends RealizeTableRowActions {
	static defaultProps = {
		...RealizeTableRowActions,
		rowActionComponent: TableRowActionButton,
	};

	constructor(props) {
		super(props);
		this.renderButtons = TableRowActions.prototype.renderButtons.bind(this);
	}

	renderButton(actionButton, index) {
		const { rowActionComponent: RowActionComponent, data, dataRowIdField } = this.props;

		return (
			<RowActionComponent
				key={"action_" + index}
				{...actionButton}
				dataRowIdField={dataRowIdField}
				data={data} />
		);
	}

	renderButtons() {
		return this.props.actionButtons.map(this.renderButton.bind(this));
	}
}
